import { View, Text } from '@react-pdf/renderer';
import React from 'react';
import { FlexTableCellItem } from '../../types';
import styles from '../../styles';
import { TableState } from '../../utils';

type FlexTableHeadingRowProps = {
  row: FlexTableCellItem[];
  tableState: TableState;
  pageNumber: number;
  continuedText: string;
};

/**
 * FlexTableHeadingRow renders the table heading/title row.
 * Shows "Continued" text when the heading appears on a page
 * after the first page that has items (body rows).
 */
const FlexTableHeadingRow: React.FC<FlexTableHeadingRowProps> = ({
  row,
  tableState,
  pageNumber,
  continuedText = 'Continued'
}) => {
  const heading = row[0]?.label;

  if (!heading) {
    return <Text />;
  }

  const { itemsPerPage } = tableState;

  // Find the first page that has items (body rows)
  const pagesWithItems = Object.keys(itemsPerPage)
    .map(Number)
    .filter(page => itemsPerPage[page] && itemsPerPage[page].length > 0);

  const firstPageWithItems =
    pagesWithItems.length > 0 ? Math.min(...pagesWithItems) : pageNumber;

  // Show "Continued" if this page is after the first page with items
  const isContinued = pageNumber > firstPageWithItems;

  return (
    <View style={styles.header}>
      <Text style={styles.headerText}>
        {heading}{' '}
        {isContinued ? (
          <Text style={styles.headerTextContinued}>{continuedText}</Text>
        ) : (
          <Text />
        )}
      </Text>
    </View>
  );
};

export default FlexTableHeadingRow;
